import React from "react";
import * as Icon from "react-bootstrap-icons";
import * as Utils from "../../inc/Utils";
import {Link, NavLink} from "react-router-dom";
import Role from "../../inc/Role";
import toast, { Toaster } from 'react-hot-toast';

import Pagination from "react-js-pagination";
import {Config} from '../../Config'

export default function AdsNaming() {
    const roles = new Role();
    //region search
    let btnTextDefault = 'ค้นหา';
    let btnTextLoading = 'กำลังค้นหา..';
    let [showSearch, setShowSearch] = React.useState(false);
    let [itemPerpage, setItemPerpage] = React.useState(10);
    let [countAllItem, setCountAllItem] = React.useState(0);
    let [activePage, setActivePage] = React.useState(1);
    let [totalPage, setTotalPage] = React.useState(0);
    let [name, setName] = React.useState(null);
    let [sortField, setSortField] = React.useState(null);
    let [sortType, setSortType] = React.useState(null);
    let [typeId, setTypeId] = React.useState(null);
    const onSearch = (e) => {
        e.preventDefault();
        getData({
            name : e.target.elements.name.value,
            typeId : e.target.elements.typeId.value,
            sortField : e.target.elements.sortField.value,
            sortType : e.target.elements.sortType.value
        });
        setName(e.target.elements.name.value);
        setSortField(e.target.elements.sortField.value);
        setSortType(e.target.elements.sortType.value);
    };
    const onSearchReset = () => {
        setName('');
        setTypeId('');
        setSortField('orderId');
        setSortType('ASC');
        setActivePage(0);
        getData({
            name : null,
            typeId : null,
            sortField: 'orderId',
            sortType: 'ASC',
            activePage: 1
        });
    };
    const onChangeName = (value) => setName(value);
    const onChangeSortField = (Id) => setSortField(Id);
    const onChangeSortType = (Id) => setSortType(Id);
    const onChangeTypeId = (Id) => setTypeId(Id);
    const onPageChange = (pageNum) => {
        setActivePage(pageNum);
        getData({
            name : name ?? null,
            typeId : typeId ?? null,
            sortField: sortField ?? null,
            sortType: sortType ?? null,
            activePage: pageNum,
        });
    };
    //endregion

    let [isLoading, setLoading] = React.useState(false);
    let [data, setData] = React.useState('');

    React.useEffect(() => {
        getData({
            name : null,
            typeId : null,
            sortField: 'orderId',
            sortType: 'ASC'
        });
    }, []);

    const getData = (params) => {
        setLoading(true);
        if(params.itemPerpage) {
            itemPerpage = params.itemPerpage;
        }
        fetch(Config.url.API_URL +'/api/adsNaming/listing', {
            method: 'POST',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
                'x-access-token': roles.accessToken
            },
            body: JSON.stringify({
                name: params.name ?? null,
                typeId: typeId ?? null,
                sortField: params.sortField ?? 'orderId',
                sortType: params.sortType ?? 'ASC',
                itemPerpage: itemPerpage,
                startItem: params.activePage > 1 ? (params.activePage*itemPerpage)-itemPerpage : 0,
            })
        }).then(response => {
            setLoading(false);
            if(response.ok) {
                return response.json();
            }
            else {
                return response.json().then(err => Promise.reject(err));
            }
        }).then(result => {
            setCountAllItem(result.count);
            setTotalPage(result.count > 0 ? (result.count / itemPerpage) : 1);
            setData(result.rows);
        }).catch(err => {
            toast.error(err.message);
        });
    };

    const onChangeItemPerpage = (e) => {
        setItemPerpage(e.target.value);
        setActivePage(1);
        getData({
            name : null,
            nameEn : null,
            geoId: null,
            sortField: 'orderId',
            sortType: 'ASC',
            activePage: 1,
            itemPerpage: e.target.value
        });
    };

    const adsNamingType = (typeIds) => {
        let result = [];
        if(typeIds) {
            for(let rs of typeIds) {
                result.push({
                    typeName: Utils.adsNamingTypeName(rs.typeId)
                });
            }
        }
        return result;
    };

    return (
        <main><Toaster position="bottom-right" />
            <div className="row table-toolbar mb-2">
                <div className="col-6 align-self-center">
                    <div className="h6 d-inline"><span className="text-success">&#8226;</span> Master Ads Naming Format</div>
                    <span className="ms-1">/</span> <span className="text-muted">Listing</span>
                </div>
                <div className="col-6 text-end align-self-center toolbars">
                    {roles.isCreate(Utils.MENU_ADSNAMING) ? (
                        <NavLink className="btn btn-sm btn-primary" to='/adsNaming/create'><span><Icon.PlusLg/> เพิ่มข้อมูล</span></NavLink>
                    ) : ''}

                </div>
            </div>
            {isLoading ? (<span className="spinner-grow spinner-grow-sm"></span>) :
            <>
                <div className="bg-light border rounded my-2">
                    <button type="button" className="btn btn-light w-100 text-start" onClick={() => {setShowSearch(!showSearch)}}><Icon.Search/> ค้นหา | เรียงลำดับ</button>
                    <div className={showSearch ? 'd-block p-3':'d-none'}>
                        <form className="row g-3" onSubmit={onSearch} onReset={onSearchReset}>
                            <div className="col-12 col-sm-6">
                                <label htmlFor="name" className="form-label">Name</label>
                                <input type="text" className="form-control" id="name" value={name ?? ''} onChange={(event) => onChangeName(event.target.value)}  maxLength={100} />
                            </div>
                            <div className="col-12 col-sm-6">
                                <label htmlFor="sortField" className="form-label">เรียงลำดับ</label>
                                <div className="row">
                                    <div className="col-8">
                                        <select className="form-select" id="sortField" onChange={(event) => onChangeSortField(event.target.value)} value={sortField ?? ''}>
                                            <option value="orderId">OrderId</option>
                                            <option value="id">Id</option>
                                            <option value="name">ชื่อ Ads Naming</option>
                                        </select>
                                    </div>
                                    <div className="col-4">
                                        <select className="form-select" id="sortType" onChange={(event) => onChangeSortType(event.target.value)} value={sortType ?? ''}>
                                            <option value="ASC">ASC</option>
                                            <option value="DESC">DESC</option>
                                        </select>
                                    </div>
                                </div>
                            </div>
                            <div className="col-12 col-sm-6">
                                <label htmlFor="typeId" className="form-label">ประเภท</label>
                                <select className="form-select" id="typeId" onChange={(event) => onChangeTypeId(event.target.value)} value={typeId ?? ''}>
                                    <option value="">Select...</option>
                                    <option value={Utils.ADSNAMING_TYPE_CAMPAIGN}>Campaign</option>
                                    <option value={Utils.ADSNAMING_TYPE_SETNAME}>Set Name</option>
                                    <option value={Utils.ADSNAMING_TYPE_CREATIVE}>Creative</option>
                                </select>
                            </div>
                            <div className="col-12">
                                <button type="submit" className="btn btn-primary">{isLoading ? btnTextLoading : btnTextDefault}</button>
                                <button type="reset" className="btn btn-light border ms-2">รีเซ็ต</button>
                            </div>
                        </form>
                    </div>
                </div>
                {data.length <= 0 ? (<p>ไม่พบข้อมูล</p>) :
                    <>
                        <div className="table-container shadow">
                        <table className="table table-striped">
                            <thead>
                            <tr>
                                <th className="w80 text-center">
                                    {roles.isEdit(Utils.MENU_ADSNAMING) ? (
                                        <button type="button" className="btn btn-sm btn-light px-2 py-0"
                                                onClick={() => Utils.onReorder('adsNaming', data)}><span
                                            className={isLoading ? 'spinner-grow spinner-grow-sm' : 'd-none'}></span>
                                            <Icon.Save size={10}/>
                                        </button>) : '#'
                                    }
                                </th>
                                <th>ชื่อ Ads Naming</th>
                                <th className="w150">ประเภท</th>
                                <th className="w100 text-center">จัดการ</th>
                                {roles.isEdit(Utils.MENU_ADSNAMING) ? (
                                    <th className="w100 text-center">สถานะ</th>) : ''
                                }
                                <th className="w100 text-center">วันที่สร้าง</th>
                                <th className="w100 text-center">วันที่อัพเดต</th>
                                <th className="w100 text-center">เครื่องมือ</th>
                            </tr>
                            </thead>
                            <tbody>
                            {data.map((row, index) => {
                                return (
                                    <tr key={index} id={"rowId" + row.id}>
                                        <td>
                                            <input type="text" className="form-control text-center" name={"orderIds"+row.id} value={row.orderId ?? 0} onChange={(e) => Utils.onChangeOrder(e, row, data, setData)} disabled={!roles.isEdit(Utils.MENU_ADSNAMING)} />
                                        </td>
                                        <td>{row.name}</td>
                                        <td>
                                            {
                                                adsNamingType(row.items).map((rs, i) => {
                                                    return (<div key={i} className="d-block"><span className="text-warning">&#8226;</span> {rs.typeName}</div>);
                                                })
                                            }
                                        </td>
                                        <td className="text-center">
                                            {roles.isView(Utils.MENU_ADSNAMING) ? (
                                                <Link className="btn btn-sm btn-light mx-1" to={'/adsNamingSource/' + Utils.encodeItem({adsNamingId: row.id, adsNamingTitle: row.name})}><Icon.PencilSquare/></Link>
                                            ) : ''}
                                        </td>
                                        {roles.isEdit(Utils.MENU_ADSNAMING) ? (
                                            <td className="text-center">
                                                <div className="form-check form-switch">
                                                    <input className="form-check-input float-none" type="checkbox"
                                                           name="statusChecked" id="status" checked={row.status === 1}
                                                           onChange={(e) => Utils.onStatusClick(e, row, data, setData, 'adsNaming')}/>
                                                    <label className="form-check-label" htmlFor="status">

                                                    </label>
                                                </div>
                                            </td>) : ''
                                        }
                                        <td className="text-center">{Utils.dateTime(row.createdAt)}</td>
                                        <td className="text-center">{Utils.dateTime(row.updatedAt)}</td>
                                        <td className="text-center">
                                            {roles.isEdit(Utils.MENU_ADSNAMING) ? (
                                                <Link className="btn btn-sm btn-light mx-1" to={'/adsNaming/edit/' + Utils.encodeItem({id: row.id,  createdAt: row.createdAt})}><Icon.Pencil/></Link>
                                            ) : ''}
                                            {roles.isDelete(Utils.MENU_ADSNAMING) ? (
                                                <button className="btn btn-sm btn-light mx-1" onClick={() => Utils.deleteItem('adsNaming', row.id, row.name)}><Icon.Trash/></button>
                                            ) : ''}
                                        </td>
                                    </tr>
                                );
                            })
                            }
                            </tbody>
                        </table>
                        </div>
                        <div className="row mt-3">
                            <div className="col-12 col-sm-4 mt-2 mt-sm-0 text-end align-self-center">
                                <select className="form-select w100" id="itemPerpage" onChange={(e) => onChangeItemPerpage(e)} value={itemPerpage}>
                                    <option value="10">10</option>
                                    <option value="20">20</option>
                                    <option value="30">30</option>
                                    <option value="40">40</option>
                                    <option value="50">50</option>
                                    <option value="100">100</option>
                                </select>
                            </div>
                            <div className="col-12 col-sm-8">
                                <div className={totalPage > 1 ? 'my-3':'d-none'}>
                                    <Pagination
                                        itemClass="page-item"
                                        linkClass="page-link"
                                        innerClass="pagination justify-content-sm-end"
                                        activePage={activePage}
                                        itemsCountPerPage={itemPerpage}
                                        totalItemsCount={countAllItem}
                                        pageRangeDisplayed={5}
                                        onChange={(pageNum) => onPageChange(pageNum)}
                                    />
                                </div>
                            </div>
                        </div>
                    </>
                }
            </>
            }
        </main>
    );
} 